import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const StreetViewCategory = () => {
  const [streetViewCategories, setStreetViewCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [categoryName, setCategoryName] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [page, setPage] = useState(1);

  const fetchCategories = async (pageNumber = 1) => {
    try {
      const response = await axios.get(`/streetviewcategories?page=${pageNumber}`);
      setStreetViewCategories(response.data.categories);
      setLoading(false);
      setPage(pageNumber);
    } catch (error) {
      console.error('Error fetching categories', error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/streetviewcategories/${id}`)
          .then(() => {
            fetchCategories(page);
            Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
          })
          .catch((error) => {
            Swal.fire('Error!', 'Something went wrong.', 'error');
          });
      }
    });
  };

  const openModal = (category = null) => {
    setCurrentCategory(category);
    setCategoryName(category ? category.category_name : '');
    setIsEditing(!!category);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentCategory(null);
  };

  const handleSave = () => {
    const categoryData = { category_name: categoryName };

    if (isEditing) {
      axios
        .put(`/streetviewcategories/${currentCategory.id}`, categoryData)
        .then(() => {
          fetchCategories(page);
          closeModal();
        })
        .catch((error) => console.error('Error saving category', error));
    } else {
      axios
        .post('/streetviewcategories', categoryData)
        .then(() => {
          fetchCategories(page);
          closeModal();
        })
        .catch((error) => console.error('Error adding category', error));
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <h4 className="panel-title pull-left">Manage Street View Category</h4>
            {/* <button className="btn btn-default btn-sm pull-right" onClick={() => openModal()}>
              <FontAwesomeIcon icon={faPlus} /> Add Category
            </button> */}
            <Link to="/Website/StreetViewCategory/add/" className="btn btn-default btn-sm pull-right" >
              <FontAwesomeIcon icon={faPlus} /> Add Category
            </Link>
          </div>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table m-b-0">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>#</th>
                    <th>Category Name</th>
                    <th style={{ width: '1%' }} colSpan="2">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {streetViewCategories.map((category, index) => (
                    <tr key={category.id}>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        {index + 1}
                      </td>
                      <td>{category.category_name}</td>
                      <td>
                        {/* <button
                          className="btn btn-warning btn-xs"
                          onClick={() => openModal(category)}
                        >
                          <FontAwesomeIcon icon={faPencil}/>
                        </button> */}
                        <Link
                        to="/Website/StreetViewCategory/add/"
                          className="btn btn-warning btn-xs"
                          
                        >
                          <FontAwesomeIcon icon={faPencil}/>
                        </Link>
                      </td>
                      <td>
                        <button
                          className="btn btn-danger btn-xs"
                          onClick={() => handleDelete(category.id)}
                        >
                          <FontAwesomeIcon icon={faTrash}/>
                          </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog panel panel-default panel-border top">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  data-dismiss="modal"
                >
                  &times;
                </button>
                <h4 className="modal-title">Category {isEditing ? 'Edit' : 'Add'}</h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StreetViewCategory;
